import TimeUnit from './TimeUnit.jsx';

const React = require('react');
const PropTypes = require('prop-types');
const uiSettings = require('../../../utils/UISettings.js');

/**
 * Countdown React Element
 * We need "dangerouslySetInnerHTML" attribute on the message first part
 * for strings like: "Order before <span>8pm</span> for next day delivery"
 */
export default function Countdown(props) {
  if (!props.display) {
    return <span />;
  }


  const midnightText = uiSettings.get('component.mcd.text.midnight');
  let messageFirstPart = props.messageFirstPart;
  messageFirstPart = messageFirstPart.replace(midnightText,
    `<span class='text-midnight'>${midnightText}</span>`);


  return (
    <span
      className={'countdown-wrapper clock'}
      style={{ display: 'block' }}
    >
      <span
        className={'message-first'}
        color={'black'}
        dangerouslySetInnerHTML={{ __html: messageFirstPart }}
      />
      <span className={'time-items'}>
        <TimeUnit
          value={props.days}
          label={props.daysLabel}
          show={props.daysShow}
          color={props.color}
        />
        <TimeUnit
          value={props.hours}
          label={props.hoursLabel}
          show={props.hoursShow}
          color={props.color}
        />
        <TimeUnit
          value={props.minutes}
          label={props.minutesLabel}
          show={props.minutesShow}
          color={props.color}
        />
        <TimeUnit
          value={props.seconds}
          label={props.secondsLabel}
          show={props.secondsShow}
          color={props.color}
        />
      </span>
      <span className={'message-second'}>
        {props.messageSecondPart}
      </span>
    </span>
  );
}

Countdown.propTypes = {
  color: PropTypes.string.isRequired,
  daysShow: PropTypes.bool.isRequired,
  hoursShow: PropTypes.bool.isRequired,
  minutesShow: PropTypes.bool.isRequired,
  secondsShow: PropTypes.bool.isRequired,
  secondsLabel: PropTypes.string.isRequired,
  minutesLabel: PropTypes.string.isRequired,
  hoursLabel: PropTypes.string.isRequired,
  daysLabel: PropTypes.string.isRequired,
  days: PropTypes.number.isRequired,
  hours: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired,
  seconds: PropTypes.number.isRequired,
  messageFirstPart: PropTypes.string.isRequired,
  messageSecondPart: PropTypes.string.isRequired,
  display: PropTypes.bool.isRequired
};
